import { render } from "./ReturnFinanceForm.vue?vue&type=template&id=407e7670&ts=true"
import script from "./ReturnFinanceForm.vue?vue&type=script&lang=ts"
export * from "./ReturnFinanceForm.vue?vue&type=script&lang=ts"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__